import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TMenuListGetReq,
  TMenuListGetRes,
  TMyMenuInfoDeleteReq,
  TMyMenuInfoPostReq,
  TMyMenuListGetReq,
  TMyMenuListGetRes,
} from "./TMenu"

/**
 * メニューに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class MenuService extends ConnectApi {
  /**
   * メニュー一覧取得
   *
   * @param {TMenuListGetReq} params
   * @param {(param: TApiResponse<TMenuListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TMenuListGetRes>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TMenuListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TMenuListGetRes>> =
        await this.getInner(`/master/menu`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * マイメニュー一覧取得
   *
   * @param {TMyMenuListGetReq} params
   * @param {(param: TApiResponse<TMyMenuListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TMyMenuListGetRes>) => any} reject
   * @memberof MenuService
   */
  getMyMenuList = async (params: TMyMenuListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TMyMenuListGetRes>> =
        await this.getInner(`/master/mymenu`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * マイメニュー登録
   *
   * @param {TMyMenuInfoPostReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof KyotenService
   */
  postMyMenu = async (data: TMyMenuInfoPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/master/mymenu`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * マイメニュー削除
   *
   * @param {TMyMenuInfoDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof KyotenService
   */
  deleteMyMenu = async (data: TMyMenuInfoDeleteReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `/master/mymenu`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
